import { rootApi } from '../../user/api';

// Define a service using a base URL and expected endpoints
const apiWithTag = rootApi.enhanceEndpoints({
  addTagTypes: ['vehicleTypeChanges'],
});
export const vehicleTypeChangesApi = apiWithTag.injectEndpoints({
  endpoints: (builder) => ({
    findAllvehicleTypeChanges: builder.query({
      query: () => `vehicle_type_changes/`,
      providesTags: ['vehicleTypeChanges'],
    }),
    findvehicleTypeChangesById: builder.query({
      query: (id) => `vehicle_type_changes/${id}/`,
      providesTags: (result, error, arg) => {
        return result
          ? [{ type: 'vehicleTypeChanges', id: result.id }]
          : ['vehicleTypeChanges'];
      },
    }),
    createvehicleTypeChanges: builder.mutation({
      query: (vehicleTypeChanges) => ({
        url: `vehicle_type_changes/`,
        method: 'POST',
        body: vehicleTypeChanges,
      }),
      invalidatesTags: ['vehicleTypeChanges'],
    }),
    updatevehicleTypeChanges: builder.mutation({
      query: (vehicleTypeChanges) => ({
        url: `vehicle_type_changes/${vehicleTypeChanges.id}/`,
        method: 'PATCH',
        body: vehicleTypeChanges,
      }),
      invalidatesTags: ['vehicleTypeChanges'],
    }),
    deletevehicleTypeChanges: builder.mutation({
      query: (vehicleTypeChanges) => ({
        url: `vehicle_type_changes/${vehicleTypeChanges.id}/`,
        method: 'DELETE',
      }),
      invalidatesTags: ['vehicleTypeChanges'],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useFindAllvehicleTypeChangesQuery,
  useFindvehicleTypeChangesByIdQuery,
  useCreatevehicleTypeChangesMutation,
  useUpdatevehicleTypeChangesMutation,
  useDeletevehicleTypeChangesMutation,
} = vehicleTypeChangesApi;
